import currentEditorStore     from '@/TokamapEditor/stores/currentEditorStore';
import { FormModal }          from '@widesk-ui/components/modal/FormModal';
import FileForm               from '@/forms/FileForm';
import { Shape }              from '@tokamap/core';
import { isBlockedByLimit }   from '@/components/Functionality/functionalityGuards';
import { functionalityStore } from '@/components/Functionality';
import preventConcurrentCalls from '@/tools/preventConcurrentCalls';

async function checkAndReplaceFeatureImage(shape: Shape, title = `Remplacer l'image`) {
	const editor = currentEditorStore.get;
	const mapUrn = currentEditorStore.map?.urn;

	if (await isBlockedByLimit({ reference: 'nb_images' })) return;

	return FormModal.open({
		children: (
			<FileForm
				forceSvgToHaveWidthAndHeight
				typeReference="map_image"
				sourceUrn={mapUrn}
				hideDescription
				hideType
				submitOnChange
				required
				onSuccessFiles={async files => {
					functionalityStore.refreshUsagesOf('nb_images');

					const src = files[0]?.downloadPath;

					if (src) {
						return editor?.setShapeImage(shape.id, { src });
					}
				}}
			/>
		),
		title,
	});
}

const replaceFeatureImage = preventConcurrentCalls(checkAndReplaceFeatureImage);

export default replaceFeatureImage;
